import { createAsyncThunk } from "@reduxjs/toolkit";
import { authUserInfoService } from "services";

export const fetchingUserSessionAction = createAsyncThunk(
  "auth/fetchingUserSession",
  async () => {
    const getMeRes = await authUserInfoService();
    return getMeRes?.data;
  }
);

export const initUserSessionAction = createAsyncThunk(
  "auth/initUserSession",
  async () => {
    const getMeRes = await authUserInfoService();
    return getMeRes?.data;
  }
);
